import VersionPage from './Page';
export default VersionPage;
